import '@/App.css';
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import Shell from '@/components/Shell';
import { Spinner } from '@/components/bits';
import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Signup from '@/pages/Signup';
import Dashboard from '@/pages/Dashboard';
import Coding from '@/pages/Coding';
import AppBuilder from '@/pages/AppBuilder';
import Marketing from '@/pages/Marketing';
import Wallet from '@/pages/Wallet';
import Gallery from '@/pages/Gallery';
import Admin from '@/pages/Admin';
import FacebookAIAdmin from '@/pages/FacebookAIAdmin';
import Manage from '@/pages/Manage';
import PublicApp from '@/pages/PublicApp';
import MyraChat from '@/pages/MyraChat';
import PrivacyPolicy from '@/pages/PrivacyPolicy';

function CosmicBg() { return <div className="cosmic-bg" />; }

function FullLoader() {
  return <div className="relative min-h-screen flex items-center justify-center" style={{ zIndex: 1 }}><Spinner size={34} /></div>;
}

function Protected({ children, adminOnly, fluid }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (adminOnly && user.role !== 'studio_admin') return <Navigate to="/" replace />;
  return <Shell fluid={fluid}>{children}</Shell>;
}

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (!user) return <Landing />;
  return <Shell><Dashboard /></Shell>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullLoader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <CosmicBg />
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/signup" element={<PublicOnly><Signup /></PublicOnly>} />
            <Route path="/live/:projectId" element={<PublicApp />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/" element={<HomeRoute />} />
            <Route path="/myra" element={<Protected><MyraChat /></Protected>} />
            <Route path="/coding" element={<Protected fluid><AppBuilder /></Protected>} />
            <Route path="/coding/agents" element={<Protected><Coding /></Protected>} />
            <Route path="/marketing" element={<Protected><Marketing /></Protected>} />
            <Route path="/gallery" element={<Protected><Gallery /></Protected>} />
            <Route path="/wallet" element={<Protected><Wallet /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="/facebook-ai" element={<Protected adminOnly><FacebookAIAdmin /></Protected>} />
            <Route path="/manage" element={<Protected adminOnly><Manage /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
